<!-- IPO-->
<template>
  <div class="ipo-wrap">
    <div style="display:flex;align-items: center;">
      <H3Title :title="'IPO'"></H3Title>
      <div :ltip="szmessage" class="tips"></div>
    </div>
    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"ipoCircle"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl>
    </div>
    <div class="chart debug">
      <ChartTpl
            :elementId='"ipoLine1"'
            :firstTooltip='true'
            :enableResize='true'
            :width='"100%"'
            :height='"248px"'
            :option='line1Option'
            :originData='lineData'
          ></ChartTpl>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
import ChartTpl from '@/components/ChartTpl.vue';

export default {
  name: "IPO",
  components: {
    H3Title,
    ChartTpl
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    IPO:{
      type: Object,
      default: function () {
        return {}
      }
    },
    IPO_series:{
      type: Array,
      default: function () {
        return []
      }
    }
    
  },
  data() {
    return {
      chart: {},
      szmessage: 'IPO：首次公开募股是指一家企业或公司 （股份有限公司）第一次将它的股份向公众出售（首次公开发行，指股份公司首次向社会公众公开招股的发行方式）',
      circleOption: {},
      circleData:[],
      line1Option: {},
      lineData: []
    };
  },
  watch: {
    IPO_series: {
      handler(newvalue, oldvalue){
        this.init();
      }
    }
  },
  mounted() {
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.IPO_series.length) return;
    this.init();
  },
  methods:{
    initCircle(){
      let {IPOAmount, IPOCount } = this.IPO;
      this.circleOption = this.$chartConfigs.doubleCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: 'IPO金额',
          values: [
            {
              value: IPOAmount.percentile,
              show: IPOAmount.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: 'IPO数量',
          values: [
            {
              value: IPOCount.percentile,
              show: IPOCount.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initLineBar(){
      this.line1Option = this.$chartConfigs.lineAndBar();
      this.lineData = [{
          originData: this.IPO_series
        }]
    },
    init(){
      this.initLineBar();
      this.initCircle();
    }
  }
};
</script>

<style scoped>
.ipo-wrap {
  display: flex;
  flex-direction: column;
}
.chart-1 {
  margin-top: 15px;
  height: 120px;
  flex: 0 0 auto;
  margin-bottom: 11px;
}

.chart {
  flex: 1 1 auto;
}

.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
</style>
